import React from 'react';
import styles from './style.module.css';
import StepFiveForm from '../../components/forms/step-five';

export default () => (
    <div className={styles.page}>
        <h1 className={styles.mainTitle}>Amortization Rate</h1>
        <StepFiveForm/>
    </div>
);
